<div class="prompt" *ngIf="show">
  <p>Add the Clooper app to your home screen</p>
  <button type="button" (click)="install()" class="btn btn-secondary">Install App</button>
  <button type="button" (click)="close()" class="btn btn-outline-dark">Not now</button>
</div>